import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import { SketchToolContext } from '../context';
import SketchDrawing from '../SketchDrawing';
import styles from './SketchPreviewButton.styles';
import compassNorth from '../../../images/compass-north.png';
import cn from 'classnames';
import { withStyles, CircularProgress } from '@material-ui/core';
import { AppContext } from '../../../AppContext';

const SketchPreviewButton = ({
  classes,
  title = 'Preview Sketch Image',
  // content = 'Click & drag to move geo-coordinate shapes and labels to other areas on screen.  Click on a label to show a rotate handle for rotating elements.  Use the scroll wheel to zoom and click and drag in open space to move the entire area around.',
  children,
  generatePreview,
  onSave,
  isGenerating,
}) => {
  const [open, setOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const { dispatch: appDispatch } = useContext(AppContext);

  const handleButtonClick = () => {
    setOpen(!open);
    generatePreview();
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await onSave();

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: 'Sketch saved successfully!',
          variant: 'success',
        },
      });

      setOpen(false);
    } catch (error) {
      console.log(error);

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: 'Sketch save failed...',
          variant: 'success',
        },
      });
    }
    setIsSaving(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Button onClick={handleButtonClick} style={{ width: '100%' }} variant="contained" color="primary">
          Generate Sketch Preview
        </Button>
      </FormControl>
      <Dialog fullWidth maxWidth="lg" open={open} onClose={() => !isSaving && setOpen(!open)}>
        <div className={cn('row-between-center')}>
          <DialogTitle id="alert-dialog-title" className={cn('row-between-center')}>
            {title}
          </DialogTitle>
        </div>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose} disabled={isSaving}>
            Close
          </Button>
          <Button color="primary" onClick={handleSave} disabled={isSaving || isGenerating}>
            {isSaving ? (
              <React.Fragment>
                Saving
                <CircularProgress size={20} style={{ marginLeft: 10 }} />
              </React.Fragment>
            ) : (
              'Save Changes'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
SketchPreviewButton.defaultProps = {};
SketchPreviewButton.propTypes = {};

export default withStyles(styles)(SketchPreviewButton);
